'use client';

import {
    BREAKPOINTS,
    clsx,
    getStoreDisplayTime,
    storeIsOpen,
    useStore,
    useWindowSize,
    usePageLayout,
} from '@libs/common-next';
import { Button } from '@petsmart-ui/sparky';
import './Location.scss';

export default function Location() {
    const { selectedStore } = useStore();
    const { data: store } = selectedStore;
    const size = useWindowSize();
    const classes = clsx(
        'location-icon',
        'sparky-u-margin-right-xs',
        size > BREAKPOINTS.lg ? 'sparky-u-margin-left-md' : null
    );

    const { setStoreDrawerOpen } = usePageLayout();

    const openStoreDrawer = (e: React.MouseEvent) => {
        e.preventDefault();
        setStoreDrawerOpen({ pageType: 'hcp' });
    };

    const timezonedDate =
        store &&
        new Date().toLocaleString('en', {
            timeZone: store.TimeZone?.TimeZoneId,
        });

    // date we are comparing to uses the timezone of the store we are using
    const currentDate = timezonedDate && new Date(timezonedDate);

    const locationClassName =
        store &&
        currentDate &&
        clsx('location-status', storeIsOpen(store, currentDate) ? 'location-open' : 'location-closed');

    return (
        <div data-testid="location" className="location">
            <div className="location-section">
                <Button
                    text={<span className="location-name">{store?.Name ?? 'Find a Store'}</span>}
                    variant="link"
                    className={classes + ' location-status-block'}
                    onClick={openStoreDrawer}
                    iconName="pin-outline"
                    iconPosition="before"
                    iconSize="sm"
                />
                {store && locationClassName && (
                    <span className={locationClassName}>{getStoreDisplayTime(store, currentDate)}</span>
                )}
            </div>
        </div>
    );
}
